export default __webpack_public_path__ + "static/media/date-picker-default.466b46c6.svg";